import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  countriesWithData,
  subscriptionPlans,
  subscriptionIntervals,
  API_URL,
} from "../redux/constants";
import { UserActions } from "../redux/UserActions";
import { XIcon, PlusIcon, ArrowLeftIcon } from "@heroicons/react/solid";
import { Link } from "react-router-dom";
import Button from "./Helper/Button";

function Setup() {
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);

  const [error, setError] = useState("");
  const [step, setStep] = useState(0);
  const [tempInput, setTempInput] = useState("");
  const [savedCSV, setSavedCSV] = useState(false);

  const [organization, setOrganization] = useState({
    departments: [],
    locations: [],
    users: [],
  });

  const [users, setUsers] = useState([]);

  return (
    <div className="flex w-full items-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="flex max-w-4xl h-full w-full md:h-auto md:mx-auto justify-center overflow-hidden bg-white md:rounded-lg shadow-xl dark:bg-gray-800">
        <div className="flex flex-col w-full overflow-y-auto md:flex-row">
          <main className="flex flex-col w-full gap-y-1 justify-center p-6 sm:p-12">
            {error === "" ? null : (
              <>
                <label className="text-center font-medium text-black py-2 w-full bg-red-500 rounded-md h-10">
                  {error}
                </label>
              </>
            )}
            {step == 0 ? (
              <>
                <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  Getting Started.
                </h1>

                <Button
                  className="my-2 py-2 w-full text-center text-white font-medium rounded bg-indigo-800"
                  handleClick={(e) => {
                    setStep(step + 1);
                  }}
                  label="Setup Organisation"
                />
              </>
            ) : null}
            {step == 1 ? (
              <>
                <h1 className="flex items-center gap-x-2 mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  <ArrowLeftIcon
                    className="w-6 cursor-pointer"
                    onClick={() => setStep(step - 1)}
                  />
                  Setup Departments
                </h1>

                <span className="w-full flex p-2 gap-x-2 gap-y-2 h-30 border ">
                  {organization.departments.map((department) => (
                    <div className="bg-blue-200  rounded flex">
                      <label className="p-2">{department}</label>
                      <XIcon
                        className="rounded-r bg-red-200 w-6 "
                        type="button"
                      />
                    </div>
                  ))}

                  <div className="bg-blue-200 border border-gray-400 rounded flex">
                    <input
                      className="rounded-l bg-transparent border-0"
                      type="text"
                      value={tempInput}
                      onChange={(e) => setTempInput(e.target.value)}
                    />
                    <PlusIcon
                      className="rounded-r bg-green-200 w-8 "
                      type="button"
                      onClick={() => {
                        setOrganization({
                          ...organization,
                          departments: [...organization.departments, tempInput],
                        });
                        setTempInput("");
                      }}
                    />
                  </div>
                </span>

                <Button
                  className="my-2 py-2 w-full text-center text-white font-medium rounded bg-indigo-800"
                  handleClick={(e) => {
                    setStep(step + 1);
                  }}
                  label="Continue"
                />
              </>
            ) : null}
            {step == 2 ? (
              <>
                <h1 className="flex items-center gap-x-2 mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  <ArrowLeftIcon
                    className="w-6 cursor-pointer"
                    onClick={() => setStep(step - 1)}
                  />
                  Setup Locations
                </h1>

                <span className="w-full flex p-2 gap-x-2 gap-y-2 h-30 border ">
                  {organization.locations.map((department) => (
                    <div className="bg-blue-200  rounded flex">
                      <label className="p-2">{department}</label>
                      <XIcon
                        className="rounded-r bg-red-200 w-6 "
                        type="button"
                      />
                    </div>
                  ))}

                  <div className="bg-blue-200 border border-gray-400 rounded flex">
                    <input
                      className="rounded-l bg-transparent border-0"
                      type="text"
                      value={tempInput}
                      onChange={(e) => setTempInput(e.target.value)}
                    />
                    <PlusIcon
                      className="rounded-r bg-green-200 w-8 "
                      type="button"
                      onClick={() => {
                        setOrganization({
                          ...organization,
                          locations: [...organization.locations, tempInput],
                        });
                        setTempInput("");
                      }}
                    />
                  </div>
                </span>

                <Button
                  className="my-2 py-2 w-full text-center text-white font-medium rounded bg-indigo-800"
                  handleClick={(e) => {
                    setStep(step + 1);
                  }}
                  label="Continue"
                />
              </>
            ) : null}
            {step == 3 ? (
              <>
                <h1 className="flex items-center gap-x-2 mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  <ArrowLeftIcon
                    className="w-6 cursor-pointer"
                    onClick={() => setStep(step - 1)}
                  />
                  Import Users
                </h1>

                <span className="w-full flex p-2 gap-x-2 gap-y-2 h-30 border ">
                  {organization.users.map((user) => (
                    <div className="bg-blue-200  rounded flex">
                      <label className="p-2">{user}</label>
                      <XIcon
                        className="rounded-r bg-red-200 w-6 "
                        type="button"
                      />
                    </div>
                  ))}

                  <div className="bg-blue-200 border border-gray-400 rounded flex">
                    <input
                      className="rounded-l bg-transparent border-0"
                      type="text"
                      value={tempInput}
                      onChange={(e) => setTempInput(e.target.value)}
                    />
                    <PlusIcon
                      className="rounded-r bg-green-200 w-8 "
                      type="button"
                      onClick={() => {
                        setOrganization({
                          ...organization,
                          users: [...organization.users, tempInput],
                        });
                        setTempInput("");
                      }}
                    />
                  </div>
                </span>
                <span className="flex bg-green-300">
                  {savedCSV ? (
                    <>
                      <label className="p-2 font-medium ">Upload CSV</label>
                      <input
                        type="file"
                        className="my-2 py-2 w-full text-center text-white font-medium rounde"
                      />
                    </>
                  ) : (
                    <>
                      <a
                        href="https://static.wellm8.com/templates/Template.xlsx"
                        className="p-2 font-medium "
                        onClick={() => setSavedCSV(true)}
                      >
                        Download CSV Template
                      </a>
                    </>
                  )}
                </span>
                <Button
                  className="my-2 py-2 w-full text-center text-white font-medium rounded bg-indigo-800"
                  handleClick={(e) => {
                    setStep(step + 1);
                  }}
                  label="Continue"
                />
              </>
            ) : null}
            {step == 4 ? (
              <>
                <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                  Setup Complete
                </h1>

                <Link
                  className="my-2 py-2 w-full text-center text-white font-medium rounded bg-indigo-800"
                  to="/dashboard"
                >
                  Continue
                </Link>
              </>
            ) : null}
          </main>
        </div>
      </div>
    </div>
  );
}

export default Setup;
